const model = [
  {
    key: 'campaignId',
    label: 'Campaign Id',
  },
  {
    key: 'shopUserId',
    label: 'User ID',
  },
  { key: 'accountCode', label: 'Account Code' },
  {
    key: 'userEmail',
    label: 'Email',
  },
  {
    key: 'legacyPostId',
    label: 'Product ID',
  },
  {
    key: 'sku',
    label: 'SKU',
  },
  {
    key: 'shippingState',
    label: 'Ship State',
  },
  {
    key: 'shippingCountry',
    label: 'Ship Country',
  },
  {
    key: 'productName',
    label: 'Name',
  },
  {
    key: 'quantityChange',
    label: 'Quantity Change',
  },
  {
    key: 'salePrice',
    label: 'Sale Price',
  },
  {
    key: 'adminShopUserId',
    label: 'Admin User ID',
  },
  {
    key: 'createdTs',
    label: 'Created At',
  },
  {
    key: 'windowType',
    label: 'Window Type',
  },
];

export default model;
